import React from 'react';
import ReviewForm from './ReviewForm';
import { useState } from 'react';

const ReviewsSection = () => {
  const [showReviewForm, setShowReviewForm] = useState(false);

  const reviews = [
    {
      id: 1,
      image: '/images/review1.jpg',
      alt: 'Customer review 1'
    },
    {
      id: 2,
      image: '/images/review2.jpg',
      alt: 'Customer review 2'
    },
    {
      id: 3,
      image: '/images/review3.jpg',
      alt: 'Customer review 3'
    },
    {
      id: 4,
      image: '/images/review4.jpg',
      alt: 'Customer review 4'
    },
    {
      id: 5,
      image: '/images/review5.jpg',
      alt: 'Customer review 5'
    },
    {
      id: 6,
      image: '/images/review6.jpg',
      alt: 'Customer review 6'
    },
    {
      id: 7,
      image: '/images/review7.jpg',
      alt: 'Customer review 7'
    },
    {
      id: 8,
      image: '/images/review8.jpg',
      alt: 'Customer review 8'
    },
    {
      id: 9,
      image: '/images/review9.jpg',
      alt: 'Customer review 9'
    },
    {
      id: 10,
      image: '/images/review10.jpg',
      alt: 'Customer review 10'
    },
    {
      id: 11,
      image: '/images/review11.jpg',
      alt: 'Customer review 11'
    },
    {
      id: 12,
      image: '/images/review12.jpg',
      alt: 'Customer review 12'
    },
  ];

   // Triple duplication for seamless loop
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  // Split reviews into 2 rows for mobile
  const firstRow = duplicatedReviews.filter((_, index) => index % 2 === 0);
  const secondRow = duplicatedReviews.filter((_, index) => index % 2 === 1);

  const ReviewCard = ({ review }) => (
    <div className="flex-shrink-0 w-48 md:w-80 lg:w-96 mx-2 md:mx-4">
      <div className="bg-white rounded-2xl md:rounded-1xl overflow-hidden shadow-lg md:shadow-2xl hover:shadow-rose-200 hover:scale-105 transition-all duration-300">
        <img
          src={review.image}
          alt={review.alt}
          className="w-full h-auto object-cover"
        />
      </div>
    </div>
  );

  return (
    <div className="w-full bg-pink-80 py-16 md:py-20 lg:py-24 overflow-hidden relative">

      <div className="max-w-7xl mx-auto px-4 mb-12 md:mb-12 lg:mb-16 relative z-10">
        {/* Section Header */}
        <div className="text-center">
          {/* Large star rating */}
          <div className="flex justify-center gap-1 md:gap-2 mb-8 md:mb-6">
            {[...Array(5)].map((_, i) => (
              <svg 
                key={i} 
                className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 drop-shadow-lg fill-yellow-400" 
                viewBox="0 0 20 20"
              >
                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
              </svg>
            ))}
          </div>

          <h2 
            className="text-4xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 text-rose-400"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            What Our Customers Say
          </h2>
          
          <p className="text-base md:text-xl lg:text-2xl text-gray-600 font-light mb-3 md:mb-4">
            Real messages from happy customers
          </p>

          {/* Star rating with count */}
          <div className="flex items-center justify-center gap-2 md:gap-3 text-base md:text-lg">
            <div className="flex gap-0.5 md:gap-1">
              {[...Array(5)].map((_, i) => (
                <svg 
                  key={i} 
                  className="w-5 h-5 md:w-6 md:h-6 fill-yellow-400" 
                  viewBox="0 0 20 20"
                >
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              ))}
            </div>
            <span className="font-semibold bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">
              5.0
            </span>
            <span className="text-gray-500">•  30+ Reviews</span>
          </div>
        </div>
      </div>

      {/* Infinite Scroll Container */}
      <div className="relative">
        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Mobile: 2 Rows */}
        <div className="md:hidden">
          {/* First Row - Scrolls Right */}
          <div 
            className="flex py-2 mb-2"
            style={{
              animation: 'scroll 80s linear infinite',
              width: 'max-content'
            }}
          >
            {firstRow.map((review, index) => (
              <ReviewCard key={`row1-${review.id}-${index}`} review={review} />
            ))}
          </div>

          {/* Second Row - Scrolls Left (reverse) */}
          <div 
            className="flex py-2"
            style={{
              animation: 'scrollReverse 80s linear infinite',
              width: 'max-content'
            }}
          >
            {secondRow.map((review, index) => (
              <ReviewCard key={`row2-${review.id}-${index}`} review={review} />
            ))}
          </div>
        </div>

        {/* Desktop: 1 Row */}
        <div className="hidden md:block">
          <div 
            className="flex py-4 md:py-8"
            style={{
              animation: 'scroll 350s linear infinite',
              width: 'max-content'
            }}
          >
            {duplicatedReviews.map((review, index) => (
              <ReviewCard key={`desktop-${review.id}-${index}`} review={review} />
            ))}
          </div>
        </div>
      </div>

      {/* CTA button */}
      <div className="text-center mt-12 md:mt-16 lg:mt-1 relative z-10 px-4 mb-16 md:mb-1">
        <button
          onClick={() => setShowReviewForm(true)}
          className="bg-gradient-to-r from-pink-300 via-pink-300 to-pink-300 hover:from-pink-400 hover:via-pink-400 hover:to-pink-400 text-white px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-xl font-bold transition-all duration-300 hover:scale-110 shadow-xl md:shadow-2xl hover:shadow-pink-300 flex items-center gap-3 md:gap-3 mx-auto"
        >
          Leave a Review
        </button>
      </div>
      
      {showReviewForm && (
        <ReviewForm
          onClose={() => setShowReviewForm(false)}
          onSubmit={() => {
            console.log('Review submitted successfully!');
          }}
        />
      )}

      {/* Keyframes animations */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        @keyframes scrollReverse {
          0% {
            transform: translateX(-33.333%);
          }
          100% {
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ReviewsSection;